<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-08-22 18:06:55
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="permission">
    <el-form ref="form"
             :model="form"
             label-width="130px"
             resetFields>
      <el-form-item label="盘点权限:">
        <el-radio-group v-model="form.take_stock_on_off">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <span class="tips">启用后可以使用扫码盘点功能</span>
      </el-form-item>
      <el-form-item label=""
                    v-if='form.take_stock_on_off=="1"'>
        <el-checkbox v-model="form.take_stock_for_all_shop"
                     :checked='form.take_stock_for_all_shop==1'
                     false-label='0'
                     true-label="1">允许所有门店</el-checkbox>
        <el-checkbox v-model="form.take_stock_for_all_dealer"
                     :checked='form.take_stock_for_all_dealer==1'
                     false-label='0'
                     true-label="1">允许所有经销商</el-checkbox>
        <el-checkbox v-model="form.take_stock_for_staff"
                     :checked='form.take_stock_for_staff==1'
                     false-label='0'
                     true-label="1">允许以下员工类型代自己管理区域内的门店盘点</el-checkbox>
      </el-form-item>
      <el-row v-if='form.take_stock_for_staff==1&&form.take_stock_on_off=="1"'>
        <el-col :offset="1">
          <el-form-item label="">
            <el-checkbox-group v-model="form.take_stock_for_staff_types">
              <el-checkbox :label="v.id"
                           v-for="(v,k) in StaffType"
                           :key='k'>{{v.type_name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="零售扫码权限:">
        <el-radio-group v-model="form.retail_on_off">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <span class="tips">启用后可以使用零售扫码功能</span>
      </el-form-item>
      <el-form-item label=""
                    v-if='form.retail_on_off==1'>
        <el-checkbox v-model="form.retail_for_all_shop"
                     :checked='form.retail_for_all_shop==1'
                     false-label='0'
                     true-label="1">允许所有门店</el-checkbox>
        <el-checkbox v-model="form.retail_for_all_dealer"
                     :checked='form.retail_for_all_dealer==1'
                     false-label='0'
                     true-label="1">允许所有经销商</el-checkbox>

      </el-form-item>
      <el-form-item label="员工调拨管理权限:">
        <el-radio-group v-model="form.staff_transfers_on_off">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <span class="tips">启用后可以使用调拨管理功能</span>
      </el-form-item>
      <el-row v-if='form.staff_transfers_on_off==1'>
        <div class="tips"
             style='text-indent: 5em;margin-bottom:5px;font-size:15px;'> 允许以下员工类型拥有调拨管理权限，且只能操作自己管理区域内的经销商</div>

        <el-col>
          <el-form-item label="">
            <el-checkbox-group v-model="form.staff_transfers_types">
              <el-checkbox :label="v.id"
                           name="staffType"
                           v-for="(v,k) in StaffType"
                           :key='k'>{{v.type_name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="员工统计管理:">
        <el-radio-group v-model="form.staff_statistics_on_off">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <span class="tips">启用后可以使用统计管理功能</span>
      </el-form-item>

      <div v-if='form.staff_statistics_on_off==1'>
        <div class="tips"
             style='text-indent: 5em;margin-bottom:5px;font-size:15px;'>允许以下员工类型拥有对应的统计查看权限，且只能查看自己管理区域内的数据</div>

        <el-row v-for="(v,k) in StaffType"
                :key='k'>

          <el-col :offset="1">
            <el-form-item label="">
              <el-checkbox v-model="Staffs[k].staff_type"> {{v.type_name}}</el-checkbox>
              <el-row>
                <el-col :offset="1"
                        v-if='Staffs[k].staff_type'>
                  <el-form-item label="">
                    <el-checkbox v-model='Staffs[k].staff_permission.dealer_validity_statistics'
                                 :checked='Staffs[k].staff_permission.dealer_validity_statistics=="1"'
                                 false-label='0'
                                 true-label="1"
                                 name="1">经销商效期统计</el-checkbox>
                    <el-checkbox v-model='Staffs[k].staff_permission.dealer_dead_stock_statistics'
                                 :checked='Staffs[k].staff_permission.dealer_dead_stock_statistics=="1"'
                                 false-label='0'
                                 true-label="1"
                                 name="1">经销商呆滞品统计</el-checkbox>
                    <el-checkbox v-model='Staffs[k].staff_permission.dealer_inventory_statistics'
                                 :checked='Staffs[k].staff_permission.dealer_inventory_statistics==1'
                                 false-label='0'
                                 true-label='1'
                                 name="1">经销商库存统计</el-checkbox>
                    <el-checkbox v-model='Staffs[k].staff_permission.shop_inventory_statistics'
                                 :checked='Staffs[k].staff_permission.shop_inventory_statistics=="1"'
                                 false-label='0'
                                 true-label="1"
                                 name="1">门店库存统计</el-checkbox>

                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

    </el-form>
    <div class="foot">
      <el-button type="primary"
                 @click='save'>保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'permission',
  data () {
    return {
      form: {
        take_stock_on_off: "",
        take_stock_for_all_dealer: '',
        take_stock_for_all_shop: "",
        take_stock_for_staff: '',
        take_stock_for_staff_types: [],
        retail_on_off: "",
        retail_for_all_shop: "",
        retail_for_all_dealer: "",
        staff_transfers_on_off: "",
        staff_transfers_types: [],
        staff_statistics_on_off: "",
        staff_statistics_types: []
      },
      StaffType: [],
      Staffs: [],

    }
  },
  methods: {
    //获取基础配置
    getConfig () {
      this.$get('logistics', '/configs.permission', {
        lang: '',
      }).then(res => {
        this.form = res.data
        this.form.take_stock_for_staff_types.forEach((v, k) => {
          this.form.take_stock_for_staff_types[k] = Number(v)
        });
        this.form.staff_transfers_types.forEach((v, k) => {
          this.form.staff_transfers_types[k] = Number(v)
        });

        var temp = false
        var staffs = []
        this.StaffType.forEach(function (item) {
          temp = false
          res.data.staff_statistics_types.forEach((element) => {
            console.log(element)
            if (item.id == element.staff_type) {

              staffs.push({
                staff_type: true,
                id: element.staff_type,
                staff_permission: element.staff_permission
              });
              temp = true
            }
          })
          if (!temp) {
            staffs.push({
              staff_type: false,
              id: item.id,
              staff_permission: {

              }
            })
          }

        })
        this.Staffs = staffs
      })

    },
    // 获取员工类型
    getStaffType () {
      this.$get('logistics', '/staffs.types').then(res => {
        this.StaffType = res.data
        this.getConfig()
      })
    },
    upEL (val, k) {
      console.log(val, k, "123")
      if (val) {
        this.Staffs[k].staff_permission.dealer_inventory_statistics = "1"
      } else {
        this.Staffs[k].staff_permission.dealer_inventory_statistics = "0"
      }
      console.log()
    },
    save () {

      var data = []
      this.Staffs.forEach(element => {
        if (element.staff_type) {
          data.push({
            staff_type: element.id,
            staff_permission: element.staff_permission
          })
        }

      });
      this.$put('logistics', '/configs.permission', {
        _method: 'PUT',
        ...this.form,
        staff_statistics_types: JSON.stringify(data)
      }).then(res => {
        this.$message({
          type: 'success',
          message: '保存成功'
        })
        // this.router.go(1)
      })
    }


  },
  created () {
    this.getStaffType()
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
/deep/.el-checkbox-group {
  // width: 10%!important;
  margin-right: 15px;
  display: inline-block !important;
}
/deep/ .foot {
  text-align: center;
  /deep/ .el-button {
    display: inline-block;
  }
}
.tips {
  color: #bbb;
  margin-left: 15px;
}
</style>

